import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-188" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-189" data-mp="o3x6ezc1ud6h">
        <SectionHeading id="summary-title" data-id="element-190" data-mp="j882ykwwsc4w">Everything Included:</SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-electric/30 bg-panel sm:grid-cols-2" data-id="element-191" data-mp="1gvgvv0z8ongx">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-electric/15 p-4 sm:odd:border-r" data-id="element-192" data-mp="1bwnhl6c4osfp">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-electric" data-id="element-193" data-mp="16yuc6fing2gh">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-194" data-mp="3rn08eva85148" />
              </span>
              <b className="text-sm text-white" data-id="element-195" data-mp="3nleq2uex7umn">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}